let isVariationFromContentfulEnabled: boolean | undefined;
let variationValue: string | undefined;

const getVariationFromContentful = (() => {
    if (isVariationFromContentfulEnabled !== undefined) {
        return isVariationFromContentfulEnabled;
    }
    try {
        isVariationFromContentfulEnabled =
            window.dazn.features.getVariableBooleanAnonymous(
                'f_unified_landingpage_web',
                'getVariationFromContentful'
            );
        return isVariationFromContentfulEnabled;
    } catch (_err) {
        return false;
    }
})();

const getVariationValue = (() => {
    if (variationValue !== undefined) {
        return variationValue;
    }
    try {
        variationValue = window.dazn.experiment.activateAnonymous(
            'f_unified_landingpage_web'
        )?.toLowerCase();
        return variationValue;
    } catch (_err) {
        return '';
    }
})();

export {getVariationFromContentful, getVariationValue};
